import React from "react";

const QuoteDetailsPanel = ({ quote }) => {
  if (!quote) return null;

  return (
    <div className="order-details-panel">
      <div className="order-details-block">
        <h4>Contact</h4>
        <dl className="order-details-dl">
          <div className="order-details-row">
            <dt>Name</dt>
            <dd>{quote.name}</dd>
          </div>
          <div className="order-details-row">
            <dt>Email</dt>
            <dd>{quote.email}</dd>
          </div>
          <div className="order-details-row">
            <dt>Phone</dt>
            <dd>{quote.phone}</dd>
          </div>
          {quote.company && (
            <div className="order-details-row">
              <dt>Company</dt>
              <dd>{quote.company}</dd>
            </div>
          )}
        </dl>
      </div>

      <div className="order-details-block">
        <h4>Request details</h4>
        <dl className="order-details-dl">
          <div className="order-details-row">
            <dt>Category</dt>
            <dd>{quote.category}</dd>
          </div>
          {quote.quantity && (
            <div className="order-details-row">
              <dt>Quantity</dt>
              <dd>{quote.quantity}</dd>
            </div>
          )}
          {quote.location && (
            <div className="order-details-row">
              <dt>Location</dt>
              <dd>{quote.location}</dd>
            </div>
          )}
        </dl>
        <p className="order-details-notes">{quote.message}</p>
      </div>
    </div>
  );
};

export default QuoteDetailsPanel;
